var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, listing_index, ab_test_flag, srp_view_type, ab_similar_homes_type} = options;
__p+='\n\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-card-compact browse-module-card js-tracking" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'">\n  <div class="js-component_property-card js-quick-view" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'">\n    <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" class="bm-link-overlay" data-omtag=';
 if (ab_test_flag) { if(srp_view_type == 'list') { 
__p+=' "'+
((__t=( `for_sale:srp_list:similar_homes:listing_thumb_${listing_index + 1}`))==null?'':__t)+
'" ';
 } else if (srp_view_type == 'map') { 
__p+=' "'+
((__t=( `for_sale:srp_map:similar_homes:listing_thumb_${listing_index + 1}`))==null?'':__t)+
'" ';
 } } else { 
__p+='ldp:'+
((__t=( ab_similar_homes_type ))==null?'':__t)+
':thumb_'+
((__t=( listing_index+1 ))==null?'':__t)+
' ';
 } 
__p+=' itemprop="url" target="_blank"></a>\n  \n  ';

  let photo_class = '';
  if (!property.photo_url) { photo_class = "photo-not-available-480w"};
  
__p+='\n\n  <div class="data-wrap"\n    id="'+
((__t=( listing_index + 1 ))==null?'':__t)+
'"\n    data-advertiserid-agent="'+
((__t=( property.agent_advertiser_id ))==null?'':__t)+
'"\n    data-advertiserid-office="'+
((__t=( property.office_advertiser_id ))==null?'':__t)+
'"\n    data-advertiserid-broker="'+
((__t=( property.broker_advertiser_id ))==null?'':__t)+
'"\n    data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'"\n    data-omtag="for_sale:srp_list:similar_homes:listing_thumb_'+
((__t=( listing_index + 1 ))==null?'':__t)+
'"\n    data-page="SRPLIST"\n    data-producttype="'+
((__t=( property.product_type ))==null?'':__t)+
'"\n    data-type="'+
((__t=( property.type_display ))==null?'':__t)+
'"\n    data-proptype="M"\n    data-propertytype="'+
((__t=( property.type ))==null?'':__t)+
'"\n    data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'"\n    data-status="'+
((__t=( property.status ))==null?'':__t)+
'" \n    data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'"\n    data-clickToken='+
((__t=( JSON.stringify(property.click_token) ))==null?'':__t)+
'\n    data-search_flags='+
((__t=( JSON.stringify(property.search_flags) ))==null?'':__t)+
'\n    data-price="'+
((__t=( property.price ))==null?'':__t)+
'"\n    data-product_name="'+
((__t=( property.product_name ))==null?'':__t)+
'"\n    data-baths_full="'+
((__t=( property.baths_full))==null?'':__t)+
'"\n    data-baths_half="'+
((__t=( property.baths_half ))==null?'':__t)+
'"\n    data-baths="'+
((__t=( property.baths ))==null?'':__t)+
'"\n    data-lot_size="'+
((__t=( property.lot_size_display ))==null?'':__t)+
'"\n    data-lead_attributes='+
((__t=( JSON.stringify(property.lead_attributes) ))==null?'':__t)+
'\n    add-lead-form-modal=""\n    data-gallery-photos="">\n  </div>\n\n  <div class="aspect-content compact-card-image-wrapper '+
((__t=( photo_class ))==null?'':__t)+
'">\n    ';
 if (property.photo_url){ 
__p+='\n    ';
 if (listing_index <= 5){
__p+='\n    <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n    ';
 } else { 
__p+='\n    <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="owl-lazy compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n    ';
 } 
__p+='\n    ';
 } else { 
__p+='\n    <div class="image-placeholder"></div>\n    ';
 } 
__p+='\n    <div class="compact-card-price">\n      '+
((__t=( property.price_display ))==null?'':__t)+
'\n    </div>\n    ';
 if(property.search_flags && (property.search_flags.is_new_listing || property.search_flags.is_pending || property.search_flags.is_contingent)) { 
__p+='\n    <div class="compact-card-label">\n      ';
 if(property.search_flags.is_pending){ 
__p+='\n      <span class="label label-red display-inline-block" data-label="property-label-pending">Pending</span>\n      ';
 } else if(property.search_flags.is_contingent){ 
__p+='\n      <span class="label label-red display-inline-block" data-label="property-label-contingent">Contingent</span>\n      ';
 } else if(property.search_flags.is_new_listing){ 
__p+='\n      <span class="label label-green label-outline-none display-inline-block" data-label="property-label-new">New</span>\n      ';
 } 
__p+='\n    </div>\n    ';
 } 
__p+='\n  </div>\n  <div class="compact-card-content">\n    <div class="compact-card-address ellipsis">\n      <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n        ';
 if (property.address_display){ 
__p+='\n        <span itemprop="streetAddress">'+
((__t=( property.address_display ))==null?'':__t)+
'</span>\n\n        ';
 } else { 
__p+='\n        <span itemprop="streetAddress">Address Not Available</span>\n        ';
 } 
__p+='\n      </span>\n      <span itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">\n        <meta itemprop="latitude" content="'+
((__t=( property.lat ))==null?'':__t)+
'">\n        <meta itemprop="longitude" content="'+
((__t=( property.lon ))==null?'':__t)+
'">\n      </span>\n    </div>\n    <div class="compact-card-meta">\n      ';
 if (((property.beds_display) || (property.baths_display)) || (property.sqft_display)){ 
__p+='\n      <ul class="list-horizontal list-style-disc">\n        ';
 if (property.beds_display){ 
__p+='\n        <li data-label="compact-meta-beds">'+
((__t=( property.beds_display ))==null?'':__t)+
'</li>\n        ';
 } 
__p+='\n        ';
 if (property.baths_display){ 
__p+='\n        <li data-label="compact-meta-baths">'+
((__t=( property.baths_display ))==null?'':__t)+
'</li>\n        ';
 } 
__p+='\n        ';
 if (property.sqft_display){ 
__p+='\n        <li class="compact-meta-sqft " data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</li>\n        ';
 } 
__p+='\n      </ul>\n      ';
 } else {
__p+='\n      Nearby Property\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/similar-home/browse-module-card.jst.ejs